<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-snackbar v-model="showsnackbar" bottom right color="red">
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="showsnackbar = false">
          <v-icon size="15" color="white">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex pt-4 md5 text-left>
        <v-layout wrap>
          <v-flex xs12 md6>
            <span style="font-weight: bold; font-size: 22px; color: #000000"
              >Ratings</span
            >
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs11 text-left>
            <v-layout wrap justify-center>
              <v-flex xs6 sm3 md4 text-left>
                <span
                  v-if="ratingData.rating"
                  style="
                    font-family: opensanslight;
                    font-size: 50px;
                    color: #4a3e3e;
                  "
                  >{{ parseInt(ratingData.rating) }}
                  <!-- {{ AllRatings.avg.toFixed(1) }} -->
                </span>
                <span
                  v-else
                  style="
                    font-family: opensanslight;
                    font-size: 50px;
                    color: #4a3e3e;
                  "
                  >0
                </span>
              </v-flex>
              <v-flex xs6 sm8 md8 text-left class="align-self-center">
                <v-rating
                  :value="parseInt(ratingData.rating)"
                  background-color="orange lighten-3"
                  color="orange"
                  half-increments
                  readonly
                  hover
                  small
                ></v-rating>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start>
              <v-flex xs3 sm3 md2>
                <span
                  v-if="ratingData.totalLength"
                  style="
                    font-family: poppins;
                    font-size: 14px;
                    color: #878787;
                  "
                  >{{ ratingData.totalLength }} rated</span
                >
                <span
                  v-else
                  style="
                    font-family: poppins;
                    font-size: 14px;
                    color: #878787;
                  "
                  >0 rated
                </span>
              </v-flex>
              <v-flex xs9 sm9 md10>
                <span
                  v-if="ratingData.totalReviews"
                  style="
                    font-family: poppins;
                    font-size: 14px;
                    color: #878787;
                  "
                  >{{ ratingData.totalReviews }} reviews</span
                >
                <span
                  v-else
                  style="
                    font-family: poppins;
                    font-size: 14px;
                    color: #878787;
                  "
                  >0 reviews
                </span>
              </v-flex>
            </v-layout>

            <!-- <v-layout wrap justify-start>
              <v-flex xs3 sm3 md2>
                <span
                  style="
                    font-family: opensanslight;
                    font-size: 30px;
                    color: #000000;
                  "
                  >+ 1.1</span
                >
              </v-flex>
              <v-flex xs9 sm9 md10 class="align-self-center">
                <span
                  style="
                    font-family: poppins;
                    font-size: 12px;
                    color: #000000;
                  "
                  >Increased regarding your rating</span
                >
              </v-flex>
            </v-layout> -->
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs11 md8>
            <v-layout
              wrap
              justify-start
             
            >
              <v-flex class="align-self-center">
                <v-layout wrap justify-center>
                  <v-flex xs2>
                    <v-icon color="#D1D1D1" size="12px">mdi-star</v-icon>
                    <span
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >&nbsp;5</span
                    >
                  </v-flex>
                  <v-flex xs8 class="align-self-center">
                    <v-progress-linear
                      rounded
                      background-opacity="0.5 "
                      :buffer-value="100"
                      color="green"
                      :value="ratingData.ratingPercentage.fiveStar"
                    ></v-progress-linear>
                  </v-flex>
                  <v-flex xs2 class="text-center">
                    <span
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >&nbsp;{{ ratingData.ratingPercentage.fiveStar }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
             <v-layout
              wrap
              justify-start
             
            >
              <v-flex class="align-self-center">
                <v-layout wrap justify-center>
                  <v-flex xs2>
                    <v-icon color="#D1D1D1" size="12px">mdi-star</v-icon>
                    <span
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >&nbsp;4</span
                    >
                  </v-flex>
                  <v-flex xs8 class="align-self-center">
                    <v-progress-linear
                      rounded
                      background-opacity="0.5 "
                      :buffer-value="100"
                      color="blue"
                      :value="ratingData.ratingPercentage.fourStar"
                    ></v-progress-linear>
                  </v-flex>
                  <v-flex xs2 class="text-center">
                    <span
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >&nbsp;{{ ratingData.ratingPercentage.fourStar }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
             <v-layout
              wrap
              justify-start
             
            >
              <v-flex class="align-self-center">
                <v-layout wrap justify-center>
                  <v-flex xs2>
                    <v-icon color="#D1D1D1" size="12px">mdi-star</v-icon>
                    <span
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >&nbsp;3</span
                    >
                  </v-flex>
                  <v-flex xs8 class="align-self-center">
                    <v-progress-linear
                      rounded
                      background-opacity="0.5 "
                      :buffer-value="100"
                      color="red"
                      :value="ratingData.ratingPercentage.threeStar"
                    ></v-progress-linear>
                  </v-flex>
                  <v-flex xs2 class="text-center">
                    <span
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >&nbsp;{{ ratingData.ratingPercentage.threeStar }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
             <v-layout
              wrap
              justify-start
             
            >
              <v-flex class="align-self-center">
                <v-layout wrap justify-center>
                  <v-flex xs2>
                    <v-icon color="#D1D1D1" size="12px">mdi-star</v-icon>
                    <span
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >&nbsp;2</span
                    >
                  </v-flex>
                  <v-flex xs8 class="align-self-center">
                    <v-progress-linear
                      rounded
                      background-opacity="0.5 "
                      :buffer-value="100"
                      color="green"
                      :value="ratingData.ratingPercentage.twoStar"
                    ></v-progress-linear>
                  </v-flex>
                  <v-flex xs2 class="text-center">
                    <span
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >&nbsp;{{ ratingData.ratingPercentage.twoStar }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
             <v-layout
              wrap
              justify-start
             
            >
              <v-flex class="align-self-center">
                <v-layout wrap justify-center>
                  <v-flex xs2>
                    <v-icon color="#D1D1D1" size="12px">mdi-star</v-icon>
                    <span
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >&nbsp;1</span
                    >
                  </v-flex>
                  <v-flex xs8 class="align-self-center">
                    <v-progress-linear
                      rounded
                      background-opacity="0.5 "
                      :buffer-value="100"
                      color="cyan"
                      :value="ratingData.ratingPercentage.oneStar"
                    ></v-progress-linear>
                  </v-flex>
                  <v-flex xs2 class="text-center">
                    <span
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >&nbsp;{{ ratingData.ratingPercentage.oneStar }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex pt-3 md6 text-left>
        <v-layout wrap justify-start v-if="RatingsData.length>0">
          <v-flex xs12 md6>
            <span style="font-weight: bold; font-size: 22px; color: #000000"
              >Reviews</span
            >
          </v-flex>
        </v-layout>

        <v-layout v-for="item in RatingsData" :key="item" wrap justify-start>
          <v-flex xs4>
            <v-layout wrap justify-center class="text-self-center">
              <v-flex xs2>
                <v-avatar size="25"
>
                  <v-icon > mdi-account-circle </v-icon>
                </v-avatar>
              </v-flex>
              <v-flex xs10 text-left>
                <v-layout wrap justify-start>
                  <v-flex xs12>
                    <span
                      v-if="item.uid.customerid"
                      style="
                        font-family: poppins;
                        font-size: 14px;
                        color: #000000;
                      "
                      >{{ item.uid.customerid.firstName }}
                      {{ item.uid.customerid.lastName }}</span
                    >
                  </v-flex>
                  <v-flex xs12>
                    <v-rating
                      :value="parseInt(item.rating)"
                      background-color="orange lighten-3"
                      color="orange"
                      half-increments
                      readonly
                      hover
                      small
                    ></v-rating>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs8 md6 text-right>
            <span
              style="
                font-family: poppins;
                font-size: 14px;
                color: #757575;
              "
              >Reviewed on {{formatDate(item.create_date)}}</span
            >
          </v-flex>
          <v-flex xs12 md10 text-justify>
            <span
              v-if="item.review"
              style="
                font-family: poppins;
                font-size: 16px;
                color: #000000;
              "
            >
              {{ item.review }}
            </span>
          </v-flex>
          <v-flex xs12 md10 py-2>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["ratingData","productData"],
  data() {
    return {
      RatingsData: [],
      isPurchased: false,
      rating: null,
      comment: "",
      showsnackbar: false,
      appLoading: false,
      msg: null,
      AllRatings: [],
      pr: null,
    };
  },

  mounted: function () {
    this.RatingsData = this.ratingData.data;
    // this.getPurchaseStatus();
    this.getAllProductRatings();
  },
  methods: {
    getAllProductRatings() {
      axios({
        method: "POST",
        url: "/rating/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          // pincode: localStorage.getItem("pincode"),
          productId: this.productData._id,
          ratingType:'product'
        },
      })
        .then((response) => {
          console.log("kkk", response.data.data[0]);

          this.RatingsData = response.data.data;
          for (var i = 0; i < this.RatingsData.length; i++) {
            console.log(this.RatingsData, "rat");

            console.log(this.RatingsData[i].comment, "hiii comment");
          }
          this.AllRatings = response.data;
          this.AllRatings.newData = [
            {
              value:
                (this.AllRatings.fivestarcount / this.AllRatings.count) * 100,
              color: "#31B531",
              name: "5",
              total: this.AllRatings.fivestarcount,
            },
            {
              value:
                (this.AllRatings.fourstarcount / this.AllRatings.count) * 100,
              color: "#2D86C3",
              name: "4",
              total: this.AllRatings.fourstarcount,
            },
            {
              value:
                (this.AllRatings.threestarcount / this.AllRatings.count) * 100,
              color: "#EFCF00",
              name: "3",
              total: this.AllRatings.threestarcount,
            },

            {
              value:
                (this.AllRatings.twostarcount / this.AllRatings.count) * 100,
              color: "#ff6600",
              name: "2",
              total: this.AllRatings.twostarcount,
            },

            {
              value:
                (this.AllRatings.onestarcount / this.AllRatings.count) * 100,
              color: "#DC221C",
              name: "1",
              total: this.AllRatings.onestarcount,
            },
          ];
          //this.AllRatings.avg= this.AllRatings.avg.toFixed(1)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addReview() {
      var data = {};
      data["rating"] = this.rating;
      data["comment"] = this.comment;
      data["productid"] = this.productData._id;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/review/add",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.comment = "";
            this.rating = null;
            this.appLoading = false;
            this.msg = "Review added Successfully";
            this.showsnackbar = true;
            this.getAllProductRatings();
          } else {
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getPurchaseStatus() {
      axios({
        method: "GET",
        url: "/review/ispurchased",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // pincode: localStorage.getItem("pincode"),
          productid: this.productData._id,
        },
      })
        .then((response) => {
          this.isPurchased = response.data.status;
        })
        .catch((err) => {
          console.log(err);
        });
    },
        formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>